export function isSameRoute(routeA, routeB) {
  return (
    routeA?.name === routeB?.name &&
    Number(routeA?.latitude) === Number(routeB?.latitude) &&
    Number(routeA?.longitude) === Number(routeB?.longitude)
  );
}

export function hasConsecutiveDuplicateRoutes(routes) {
  return routes.some(
    (route, index) => index > 0 && isSameRoute(routes[index - 1], route),
  );
}
